
import { formatItemQty } from '@/utils/formatUnit'
import OrderItemSpecs from '@/components/common/OrderItemSpecs.vue'
export default {
  name: 'OperatorOrderItem',
  components: { OrderItemSpecs },
  props: { item: { type: Object, required: true } },
  data () { return { broken: false } },
  computed: {
    imgSrc () { return this.broken ? this.defaultImg : (this.$img(this.item.product_image) || this.defaultImg) },
    defaultImg () { return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="60" height="60"%3E%3Crect fill="%23f0f0f0" width="60" height="60"/%3E%3C/svg%3E' },
    inspText () { return { pending: '待验货', passed: '通过', abnormal: '异常', in_progress: '验货中' }[this.item.inspection_status] || '待验货' },
    inspClass () { return { passed: 'ok', abnormal: 'bad', pending: 'wait', in_progress: 'doing' }[this.item.inspection_status] || 'wait' }
  },
  methods: { onErr () { this.broken = true }, formatItemQty }
}
